module.exports = __webpack_public_path__ + "src/components/RestoreArt/pageIcon.png?9db84110";


//////////////////
// WEBPACK FOOTER
// ./src/components/RestoreArt/pageIcon.png
// module id = 129
// module chunks = 1